export const translations = {
  fr: {
    app_name: "Cockpit OS",
    app_tagline: "Operating System",
    login_title: "Votre groupe, piloté depuis un seul écran",
    login_subtitle:
      "Toutes vos sociétés en un coup d'œil, et chaque entité en détail, le tout au même endroit.",
    login_google: "Continuer avec Google",
    login_features_1: "Tableau de bord groupe en temps réel",
    login_features_2: "Alertes automatiques & OKR transverses",
    login_features_3: "Contacts & documents partagés",
    signing_in: "Connexion en cours…",
    auth_signin_title: "Connexion",
    auth_signup_title: "Créer un compte",
    auth_name_placeholder: "Nom (facultatif)",
    auth_email_placeholder: "Adresse e-mail",
    auth_password_placeholder: "Mot de passe",
    auth_signin_cta: "Se connecter",
    auth_signup_cta: "Créer un compte",
    auth_or: "ou",
    auth_no_account: "Pas encore de compte ?",
    auth_have_account: "Vous avez déjà un compte ?",
    auth_error_generic: "Une erreur est survenue. Réessayez.",
    auth_forgot_link: "Mot de passe oublié ?",
    auth_forgot_title: "Réinitialiser le mot de passe",
    auth_forgot_subtitle: "Entrez votre e-mail, nous vous enverrons un lien de réinitialisation.",
    auth_forgot_cta: "Envoyer le lien",
    auth_forgot_sent: "Si un compte existe pour cette adresse, un lien de réinitialisation vient d'être envoyé.",
    auth_back_to_signin: "Retour à la connexion",
    auth_dev_link_note: "E-mail non configuré — lien de test :",
    auth_reset_title: "Choisir un nouveau mot de passe",
    auth_reset_subtitle: "Saisissez un nouveau mot de passe pour votre compte.",
    auth_new_password: "Nouveau mot de passe",
    auth_confirm_password: "Confirmer le mot de passe",
    auth_reset_cta: "Réinitialiser le mot de passe",
    auth_reset_success: "Mot de passe réinitialisé. Vous pouvez maintenant vous connecter.",
    auth_passwords_no_match: "Les mots de passe ne correspondent pas.",
    auth_reset_invalid: "Lien de réinitialisation invalide ou expiré.",
    auth_go_to_signin: "Aller à la connexion",

    // nav
    nav_home: "Accueil groupe",
    nav_okr: "OKR",
    nav_deals: "Deals",
    deals_new: "Nouveau deal",
    deals_edit: "Modifier le deal",
    deals_kanban: "Pipeline",
    deals_table: "Tableau",
    deals_stages: "Étapes",
    deals_manage_stages: "Gérer les étapes",
    deals_add_stage: "Ajouter une étape",
    deals_empty: "Aucun deal. Créez votre premier deal.",
    deals_open_value: "Pipeline ouvert :",
    deals_won_value: "Gagné :",
    deals_probability: "Probabilité %",
    deals_source: "Source",
    deals_contacts: "Contacts liés",
    deals_col_title: "Intitulé",
    deals_col_company: "Société",
    deals_col_stage: "Étape",
    deals_col_value: "Montant",
    deals_col_close: "Clôture prévue",
    deals_col_owner: "Responsable",
    deals_col_project: "Projet",
    deals_search_company: "Rechercher une société…",
    deals_search_project: "Rechercher un projet…",
    deals_people_filtered: "filtré par société",
    deals_no_company_people: "Aucun contact lié à cette société.",
    deals_invoice: "Facture",
    deal_won_title: "Deal gagné 🎉",
    deal_won_body: "Créer une facture brouillon pour « {title} » ({value}) ?",
    deal_won_create: "Créer la facture",
    deal_won_skip: "Plus tard",
    companies_search: "Rechercher une société…",
    companies_all_entities: "Toutes les entités",
    companies_empty: "Aucune société.",
    company_new: "Nouvelle société",
    company_edit: "Modifier la société",
    company_name_required: "Le nom est requis",
    company_website: "Site web",
    company_industry: "Secteur",
    company_location: "Localisation",
    company_entities: "Entités liées",
    company_notes: "Notes",
    stage_open: "Ouverte",
    stage_won: "Gagnée",
    stage_lost: "Perdue",
    deal_activity: "Activité & notes",
    deal_add_note: "Ajouter une note…",
    deal_no_activity: "Aucune activité pour le moment.",
    deal_act_created: "Deal créé",
    deal_act_stage: "Étape modifiée",
    deal_aging_label: "{days} j à cette étape",
    deal_aging_stale: "Au point mort · {days} j",
    deal_aging_days_short: " j",
    deal_aging_tooltip: "Sans changement d'étape depuis {days} jours",
    sales_title: "Pipeline commercial",
    sales_deals: "deals",
    nav_contacts: "Contacts",
    nav_documents: "Documents",
    drive_upload: "Téléverser",
    drive_new_folder: "Nouveau dossier",
    drive_folder_name: "Nom du dossier",
    drive_empty: "Ce dossier est vide",
    drive_drop_here: "Déposez les fichiers pour les téléverser",
    drive_col_name: "Nom",
    drive_col_size: "Taille",
    drive_col_modified: "Modifié",
    drive_col_owner: "Ajouté par",
    drive_download: "Télécharger",
    drive_rename: "Renommer",
    drive_move: "Déplacer",
    drive_delete: "Supprimer",
    drive_storage_used: "utilisé",
    drive_storage: "Stockage",
    drive_not_configured_title: "Stockage non configuré",
    drive_not_configured: "Le stockage de fichiers n'est pas encore activé. Demandez à votre administrateur de le configurer dans Admin puis Stockage.",
    drive_uploading: "Téléversement…",
    drive_upload_failed: "Échec du téléversement",
    drive_uploaded: "Fichier téléversé",
    drive_deleted: "Supprimé",
    drive_folder_created: "Dossier créé",
    drive_renamed: "Renommé",
    drive_moved: "Déplacé",
    drive_view_list: "Liste",
    drive_view_grid: "Grille",
    drive_from_board: "Tableau",
    drive_selected: "sélectionné(s)",
    drive_move_here: "Déplacer ici",
    drive_root: "Documents",
    drive_create: "Créer",
    drive_save: "Enregistrer",
    drive_cancel: "Annuler",
    drive_too_large: "Fichier trop volumineux (max 25 Mo)",
    drive_col_expiry: "Échéance",
    drive_set_expiry: "Définir l'échéance",
    drive_expiry: "Échéance / renouvellement",
    drive_expiry_hint: "Suivi des contrats et documents à renouveler — alimente les alertes du tableau de bord.",
    drive_clear_expiry: "Effacer l'échéance",
    drive_no_expiry: "Aucune échéance",
    nav_entities: "Entités",
    nav_shared: "Partagé",
    nav_settings: "Réglages",
    nav_logout: "Déconnexion",

    // periods
    period_month: "Ce mois",
    period_ytd: "Année",
    period_all: "Tout",

    // dashboard
    group_hq: "Groupe HQ",
    hq_expiring_title: "Contrats à échéance proche",
    hq_expiring_in: "Expire dans",
    entities: "entités",
    kpi_net_cashflow: "Cashflow net groupe",
    kpi_open_tasks: "Tâches ouvertes",
    kpi_portfolio: "Valeur portefeuille",
    kpi_rent: "Loyers encaissés",
    vs_last_month: "vs mois dernier",
    overdue: "en retard",
    pending: "en attente",
    mtd: "MTD",
    cashflow_by_entity: "Cashflow par entité",
    alerts: "Alertes",
    items: "éléments",
    open_tasks: "Tâches ouvertes",
    see_all: "Voir tout",
    detail: "Détail",
    portfolio: "Portefeuille",
    rents: "Loyers",
    invoices: "Factures",
    ecommerce: "Ecommerce",
    revenue: "Revenu",
    orders: "Commandes",
    avg_margin: "Marge moyenne",
    low_stock: "Alertes stock bas",
    active_campaigns: "Campagnes actives",
    days_overdue: "j de retard",
    due: "Échéance",
    done: "Fait",
    no_alerts: "Aucune alerte. Tout est sous contrôle.",
    ai_briefing: "Briefing IA du jour",
    ai_generate: "Générer le briefing",
    ai_generating: "Génération…",
    ai_regenerate: "Régénérer",

    // okr
    okr_title: "OKR — Objectifs & résultats clés",
    okr_subtitle: "Objectifs → Résultats clés → Objectifs d'équipe, sur toutes les entités",
    okr_empty: "Aucun OKR pour le moment. Créez un objectif et des résultats clés ci-dessous.",
    board: "Tableau",
    board_none: "Aucun tableau pour ce projet.",
    board_item: "Élément",
    board_add_item: "Ajouter un élément",
    board_add_column: "Ajouter une colonne",
    board_edit_column: "Modifier la colonne",
    board_edit_options: "Modifier les options",
    board_options: "Options",
    board_add_option: "Ajouter une option",
    board_color: "Couleur",
    board_done_state: "Terminé",
    board_done_hint: "Marquer cette option comme « terminé » (compte comme travail achevé)",
    board_open: "Ouvrir",
    board_group: "Groupe",
    board_group_color: "Couleur du groupe",
    board_delete_group: "Supprimer le groupe",
    board_updates: "Activité",
    board_updates_soon: "Les messages d'équipe arrivent bientôt.",
    board_subitem: "Sous-élément",
    board_subitems: "Sous-éléments",
    board_add_subitem: "+ Ajouter un sous-élément",
    board_subitem_hint: "Entrée pour ajouter",
    board_add_subcolumn: "Ajouter une colonne de sous-élément",
    board_drag_hint: "Glisser pour déplacer",
    board_nest_here: "Sous-élément",
    board_promote: "Promouvoir en élément",
    board_search_people: "Rechercher une personne…",
    board_no_members: "Aucun membre trouvé",
    role_owner: "Propriétaire",
    role_admin: "Administrateur",
    role_member: "Membre",
    role_manager: "Manager",
    role_super_admin: "Super admin",
    invite_specific_spaces: "Espaces précis",
    invite_pick_space: "Sélectionnez au moins un espace",
    scope_super_admin_note: "Accès complet au groupe — toutes les entités et tous les espaces.",
    scope_no_spaces: "Aucun espace pour le moment. Créez d'abord des espaces.",
    board_add_group: "Ajouter un groupe",
    board_column_type: "Type de colonne",
    board_column_label: "Nom de la colonne",
    board_view_table: "Tableau",
    board_view_kanban: "Kanban",
    board_view_gantt: "Gantt",
    board_view_dashboard: "Tableau de bord",
    report_error: "Impossible de charger le rapport.",
    report_total: "Total",
    report_open: "Ouverts",
    report_done: "Terminés",
    report_overdue: "En retard",
    report_completion: "Achèvement",
    report_by_status: "Répartition par statut",
    report_owner_workload: "Charge par responsable",
    report_no_open: "Aucun élément ouvert.",
    report_unassigned: "Non assigné",
    report_unknown_user: "Utilisateur",
    report_completion_trend: "Achèvement dans le temps",
    report_created: "Créés",
    report_completed: "Terminés",
    report_delivery_title: "Avancement des projets",
    report_delivery_error: "Impossible de charger l'avancement des projets.",
    report_export: "Exporter CSV",
    soon: "Bientôt",
    board_group_by: "Grouper par",
    board_no_status: "Sans statut",
    board_kanban_no_status: "Ajoutez une colonne Statut, Priorité ou Liste pour utiliser le Kanban.",
    board_gantt_no_dates: "Ajoutez une colonne Date ou Échéancier, puis renseignez des dates pour afficher le Gantt.",
    board_gantt_date_col: "Colonne de dates",
    board_today: "Aujourd'hui",
    board_no_date: "Sans date",
    board_tasks: "Éléments",
    board_gantt_hint: "Glissez une barre pour la replanifier, glissez ses bords pour la redimensionner.",
    gantt_add_item: "Nouvel élément",
    expand_all: "Tout déplier",
    collapse_all: "Tout replier",
    zoom_day: "Jour",
    zoom_week: "Semaine",
    zoom_month: "Mois",
    zoom_quarter: "Trimestre",
    zoom_year: "Année",
    gantt_link_hint: "Glissez la pastille à droite d'une barre vers une autre pour créer une dépendance.",
    gantt_remove_dep: "Cliquez pour supprimer la dépendance",
    gantt_pan_left: "Reculer",
    gantt_pan_right: "Avancer",
    drawer_details: "Détails",
    drawer_description_placeholder: "Ajoutez une description…",
    mention_everyone: "everyone",
    mention_everyone_hint: "Tout le monde sur cet espace",
    tab_updates: "Mises à jour",
    tab_files: "Fichiers",
    tab_activity: "Activité",
    updates_placeholder: "Écrivez une mise à jour…  utilisez @ pour mentionner",
    updates_reply_placeholder: "Répondre…",
    updates_mention_hint: "@ pour mentionner · **gras** *italique* `code` · ⌘/Ctrl + Entrée pour envoyer",
    updates_post: "Publier",
    updates_empty: "Aucune mise à jour pour l'instant. Lancez la conversation.",
    updates_deleted: "Mise à jour supprimée",
    updates_error: "Une erreur est survenue",
    files_add: "Joindre un fichier",
    files_empty: "Aucun fichier joint",
    files_uploaded: "Fichier ajouté",
    files_deleted: "Fichier supprimé",
    files_download: "Télécharger",
    files_error: "Échec du fichier",
    act_empty: "Aucune activité pour l'instant",
    act_created: "a créé cet élément",
    act_commented: "a publié une mise à jour",
    act_renamed: "a renommé en",
    act_moved_group: "a déplacé vers",
    act_deps: "a modifié les dépendances",
    act_description: "a modifié la description",
    mentions_title: "Mentions",
    mentions_on: "vous a mentionné sur",
    mentions_mark_all: "Tout marquer comme lu",
    mentions_dismiss: "Marquer comme traité",
    nav_inbox: "Boîte de réception",
    nav_advisory: "Conseil",
    adv_title: "Conseil",
    adv_subtitle: "Votre comité consultatif IA qui examine l'entreprise à partir de vos données Cockpit OS",
    adv_tab_review: "Revue de performance",
    adv_tab_board: "Conseil d'administration",
    adv_tab_history: "Historique / Journal",
    adv_board_soon: "Le mode Conseil d'administration arrive bientôt.",
    adv_board_soon_desc: "Une réunion interactive où les conseillers challengent vos décisions. Disponible dans une prochaine phase.",
    adv_range: "Période",
    adv_this_week: "Cette semaine",
    adv_last_week: "Semaine dernière",
    adv_this_month: "Ce mois-ci",
    adv_last_month: "Mois dernier",
    adv_custom: "Personnalisée",
    adv_from: "Du",
    adv_to: "Au",
    adv_scope: "Périmètre",
    adv_scope_group: "Tout le groupe",
    adv_scope_entity: "Une entité",
    adv_scope_entities: "Entités sélectionnées",
    adv_generate: "Générer la revue",
    adv_generating: "Les conseillers analysent vos données…",
    adv_generating_hint: "Cela prend généralement 1 à 2 minutes.",
    adv_error: "La génération a échoué. Réessayez.",
    adv_summary: "Synthèse",
    adv_improvements: "Améliorations depuis la dernière revue",
    adv_regressions: "Régressions depuis la dernière revue",
    adv_risks: "Risques",
    adv_findings: "Constats",
    adv_recommendations: "Recommandations",
    adv_sources: "Sources",
    adv_actions: "Actions recommandées",
    adv_status_healthy: "Sain",
    adv_status_needs_attention: "À surveiller",
    adv_status_at_risk: "À risque",
    adv_create_task: "Créer une tâche",
    adv_create_project: "Créer un projet",
    adv_snooze: "Reporter",
    adv_accept: "Accepter",
    adv_ignore: "Ignorer",
    adv_done: "Terminé",
    adv_act_open: "Ouverte",
    adv_act_snoozed: "Reportée",
    adv_act_accepted: "Acceptée",
    adv_act_ignored: "Ignorée",
    adv_act_done: "Terminée",
    adv_no_reviews: "Aucune revue pour l'instant. Générez votre première revue de performance.",
    adv_history: "Revues précédentes",
    adv_view: "Voir",
    adv_delete: "Supprimer",
    adv_select_entity: "Choisir une entité",
    adv_select_space: "Choisir un espace",
    adv_pick_target: "Où créer cet élément ?",
    adv_created_ok: "Créé avec succès",
    adv_at_risk_count: "à risque",
    adv_attention_count: "à surveiller",
    bm_start: "Démarrer un conseil",
    bm_new: "Nouveau conseil",
    bm_agenda: "Ordre du jour",
    bm_title: "Titre de la réunion",
    bm_question: "Question / décision / proposition",
    bm_entity: "Entité concernée (optionnel)",
    bm_none: "Aucune",
    bm_outcome: "Résultat souhaité (optionnel)",
    bm_constraints: "Contraintes (optionnel)",
    bm_advisors_optional: "Conseillers (optionnel)",
    bm_advisors_hint: "Laissez vide pour que le Directeur de cabinet choisisse les plus pertinents.",
    bm_linked_project: "Projet lié (optionnel)",
    bm_linked_goal: "Objectif lié (optionnel)",
    bm_linked_deal: "Deal lié (optionnel)",
    bm_create: "Convoquer le comité",
    bm_summary_title: "Résumé du Directeur de cabinet",
    bm_proposing: "Ce que vous proposez",
    bm_why: "Pourquoi",
    bm_upside: "Bénéfice attendu",
    bm_downside: "Risque possible",
    bm_known_data: "Données connues (Cockpit OS)",
    bm_missing: "Hypothèses manquantes",
    bm_confirm_start: "Confirmer et lancer la réunion",
    bm_questions_title: "Questions du comité",
    bm_answer_ph: "Votre réponse…",
    bm_submit_answers: "Envoyer mes réponses",
    bm_followups_title: "Questions de relance",
    bm_skip_followups: "Passer au verdict",
    bm_get_verdict: "Obtenir le verdict",
    bm_verdict_title: "Verdict du comité",
    bm_recommendation: "Recommandation",
    bm_confidence: "Confiance",
    bm_strong: "Hypothèses solides",
    bm_weak: "Hypothèses faibles",
    bm_contradictions: "Contradictions",
    bm_unanswered: "Questions sans réponse",
    bm_risks: "Risques",
    bm_data_for: "Données en faveur",
    bm_data_against: "Données en défaveur",
    bm_cheapest: "Test le moins coûteux",
    bm_objections: "Objections des conseillers",
    bm_suggested_docs: "Documents suggérés",
    bm_followup_date: "Date de suivi",
    bm_decision_log: "Entrée du journal de décision",
    bm_save_log: "Enregistrer au journal",
    bm_saved: "Enregistré au journal de décision",
    bm_working: "Le comité travaille…",
    bm_status_summarizing: "Préparation du résumé…",
    bm_status_questioning: "Le comité prépare ses questions…",
    bm_status_reviewing: "Examen de vos réponses…",
    bm_status_deliberating: "Délibération du comité…",
    rec_proceed: "Avancer",
    rec_proceed_with_conditions: "Avancer sous conditions",
    rec_delay: "Reporter",
    rec_reject: "Rejeter",
    rec_needs_more_data: "Plus de données nécessaires",
    log_filter_all: "Tout",
    log_filter_reviews: "Revues",
    log_filter_decisions: "Décisions",
    log_type_review: "Revue",
    log_type_decision: "Décision",
    hq_advisory_followups: "Suivis de décision",
    hq_followup_due: "Échu",
    auto_title: "Revue automatique",
    auto_subtitle: "Générer automatiquement une revue de performance à intervalle régulier.",
    auto_freq: "Fréquence",
    auto_off: "Désactivée",
    auto_weekly: "Hebdomadaire",
    auto_monthly: "Mensuelle",
    auto_scope: "Périmètre",
    auto_in_digest: "Inclure dans l'e-mail récap",
    auto_save: "Enregistrer",
    auto_saved: "Automatisation enregistrée",
    auto_cost_note: "Chaque exécution consomme des crédits IA.",
    inbox_subtitle: "Mentions et activité des projets que vous suivez",
    inbox_mentions: "Mentions",
    inbox_watching: "Suivi",
    inbox_no_mentions: "Aucune mention pour l'instant",
    inbox_no_watching: "Rien de nouveau sur vos projets suivis",
    inbox_posted: "a publié sur",
    inbox_added: "a ajouté",
    inbox_status_changed: "a changé le statut de",
    board_watch: "Suivre",
    board_watching: "Suivi",
    autom_button: "Automatisations",
    autom_title: "Automatisations du tableau",
    autom_empty: "Aucune automatisation. Créez une règle « quand… alors… ».",
    autom_new_rule: "Nouvelle règle",
    autom_when: "Quand",
    autom_then: "Alors",
    autom_add_action: "Ajouter une action",
    autom_name_optional: "Nom (optionnel)",
    autom_name_placeholder: "ex. Prévenir le responsable à la clôture",
    autom_saved: "Automatisation enregistrée",
    autom_save_failed: "Échec de l'enregistrement",
    autom_deleted: "Automatisation supprimée",
    autom_enabled: "Activée",
    autom_disabled: "Désactivée",
    autom_trig_status_change: "Le statut passe à…",
    autom_trig_item_created: "Un élément est créé",
    autom_trig_due_overdue: "Une date d'échéance est dépassée",
    autom_trig_overdue_short: "dépassée",
    autom_act_notify_owner: "Prévenir le responsable",
    autom_act_move_group: "Déplacer vers un groupe",
    autom_act_set_value: "Définir une valeur",
    autom_act_complete_subitems: "Terminer les sous-éléments",
    autom_act_move_to: "Déplacer vers",
    autom_act_set: "Définir",
    autom_quick_add: "Ajout rapide",
    autom_tpl_notify_done: "Prévenir le responsable à la clôture",
    autom_tpl_move_done: "Déplacer vers « Terminé » à la clôture",
    autom_tpl_complete_subs: "Terminer les sous-éléments à la clôture",
    autom_tpl_overdue: "Alerter en cas de retard",
    recur_button: "Récurrence",
    recur_title: "Éléments récurrents",
    recur_empty: "Aucun modèle récurrent. Créez-en un (ex. « TVA — mensuel »).",
    recur_new: "Nouveau modèle",
    recur_name: "Nom",
    recur_name_placeholder: "ex. Déclaration TVA",
    recur_name_required: "Le nom est requis",
    recur_frequency: "Fréquence",
    recur_next_run: "Prochaine exécution",
    recur_into_group: "Créer dans le groupe",
    recur_saved: "Modèle enregistré",
    recur_save_failed: "Échec de l'enregistrement",
    recur_deleted: "Modèle supprimé",
    recur_ran: "Élément créé",
    recur_run_now: "Exécuter maintenant",
    recur_none: "Ne pas répéter",
    recur_daily: "Quotidienne",
    recur_weekly: "Hebdomadaire",
    recur_monthly: "Mensuelle",
    recur_quarterly: "Trimestrielle",
    recur_annually: "Annuelle",
    recur_item_label: "Récurrence",
    recur_item_hint: "À la clôture, une nouvelle occurrence sera créée automatiquement.",
    invite_projects_hint: "Laissez vide pour donner accès à tous les projets des espaces choisis.",
    invite_no_projects: "Aucun projet dans les espaces sélectionnés",
    invite_operational: "Accès opérationnel",
    invite_operational_hint: "Voir aussi les onglets opérationnels (factures, portefeuille…) des entités concernées.",
    notif_title: "Notifications",
    notif_subtitle: "Soyez prévenu quand on vous mentionne dans une mise à jour.",
    notif_inapp: "Notifications dans l'app",
    notif_email: "Notifications par e-mail",
    notif_saved: "Préférences enregistrées",
    board_subitems_count: "sous-éléments",
    board_back_to_parent: "Retour à l'élément parent",
    tab_spaces: "Espaces",
    spaces_intro: "Organisez le travail de cette entité par espaces fonctionnels.",
    add_space: "Ajouter un espace",
    no_spaces: "Aucun espace pour l'instant. Ajoutez-en un pour commencer.",
    choose_space: "Choisir un espace",
    custom_space: "Espace personnalisé",
    space_name: "Nom de l'espace",
    spaces_label: "Espaces",
    spaces_form_hint: "Zones fonctionnelles préremplies selon le type d'activité. Modifiables ensuite.",
    goals: "Objectifs",
    projects: "Projets",
    add_goal: "Ajouter un objectif",
    add_project: "Ajouter un projet",
    no_goals: "Aucun objectif pour l'instant.",
    no_projects: "Aucun projet pour l'instant.",
    new_goal: "Nouvel objectif",
    edit_goal: "Modifier l'objectif",
    add_subgoal: "Ajouter un sous-objectif",
    new_project: "Nouveau projet",
    edit_project: "Modifier le projet",
    goal_name: "Nom de l'objectif",
    project_name: "Nom du projet",
    parent_group_okr: "OKR de groupe lié",
    parent_goal: "Objectif parent",
    champion: "Responsable",
    start_date: "Date de début",
    due_date: "Échéance",
    status: "Statut",
    priority: "Priorité",
    prio_low: "Faible",
    prio_medium: "Moyen",
    prio_high: "Élevé",
    targets: "Cibles",
    add_target: "Ajouter une cible",
    no_targets: "Aucune cible quantitative.",
    target_name: "Nom de la cible",
    target_value: "Cible",
    start: "Départ",
    current: "Actuel",
    unit: "Unité",
    checklist: "Checklist",
    add_check_placeholder: "Ajouter un élément…",
    subgoals_projects: "Sous-objectifs & projets",
    goal: "Objectif",
    project: "Projet",
    no_subitems: "Aucun sous-objectif ni projet.",
    back: "Retour",
    milestones: "Jalons",
    milestone_name: "Nom du jalon",
    no_milestones: "Aucun jalon pour l'instant.",
    task: "Tâche",
    task_name: "Nom de la tâche",
    other_tasks: "Autres tâches",
    resources: "Ressources",
    add_resource: "Ajouter une ressource",
    resource_label: "Libellé",
    no_resources: "Aucune ressource. Ajoutez des liens vers vos documents ou outils.",
    add_task: "Ajouter une tâche",
    new_task: "Nouvelle tâche",
    edit_task: "Modifier la tâche",
    no_tasks: "Aucune tâche pour l'instant.",
    milestone: "Jalon",
    impact_short: "I",
    effort_short: "E",
    priorities_title: "À traiter en priorité",
    priorities_subtitle: "Vos éléments ouverts les plus importants, par quadrant de priorité et échéance.",
    focus_quick_wins_label: "quick wins",
    focus_quick_win_label: "quick win",
    focus_overdue_label: "en retard",
    priorities_empty: "Rien de priorisé pour l'instant. Ajoutez impact & effort à vos objectifs, projets ou tâches.",
    alignment_title: "Alignement",
    alignment_subtitle: "Comment les résultats clés se calculent à partir des objectifs d'espace qui les font avancer.",
    objective: "Objectif",
    goals_short: "objectifs",
    manual: "manuel",
    linked_goals: "Objectifs liés",
    kr_title: "Résultat clé",
    kr_progress: "Progression",
    auto_from_goals: "auto depuis les objectifs",
    linked_key_result: "Résultat clé lié",
    edit_key_result: "Modifier le résultat clé",
    kr_link_hint: "Liez des objectifs d'espace à ce résultat clé pour calculer sa progression automatiquement.",
    objectives: "Objectifs",
    key_results: "Résultats clés",
    impact_effort: "Matrice Impact / Effort",
    impact: "Impact",
    effort: "Effort",
    quick_win: "Quick win",
    major_bet: "Pari majeur",
    fill_in: "Tâche d'appoint",
    thankless: "Tâche ingrate",
    high: "Élevé",
    low: "Faible",
    progress: "Progression",
    target: "Cible",

    // generic table
    add: "Ajouter",
    edit: "Modifier",
    delete: "Supprimer",
    save: "Enregistrer",
    cancel: "Annuler",
    confirm_delete: "Supprimer cet élément ?",
    no_data: "Aucune donnée. Cliquez sur « Ajouter » pour commencer.",
    search: "Rechercher…",
    none: "—",
    all_entities: "Toutes les entités",
    crm_title: "CRM",
    crm_subtitle: "Votre carnet d'adresses partagé — personnes et sociétés, accessibles à toutes les entités.",
    crm_people: "Personnes",
    crm_companies: "Sociétés",
    crm_filter_entity: "Afficher",
    crm_all_entities: "Toutes les entités",
    crm_tab_all: "Tous les contacts",
    crm_tab_needs: "Mises à jour requises",
    crm_needs_none: "Tous vos contacts sont à jour.",
    crm_last_contact: "Dernier contact",
    crm_never_contacted: "Jamais",
    crm_days_short: "j",
    crm_mark_followed: "Marquer comme relancé",
    crm_log_title: "Journaliser une interaction",
    crm_interaction_type: "Type d'interaction",
    crm_interaction_summary: "Résumé",
    crm_int_call: "Appel",
    crm_int_email: "Email",
    crm_int_meeting: "Réunion",
    crm_int_note: "Note",
    crm_int_other: "Autre",
    crm_timeline: "Historique des interactions",
    crm_no_timeline: "Aucune interaction enregistrée.",
    crm_contact_entities: "Entités & rôles",
    crm_add_entity_link: "Ajouter une entité",
    crm_select_entity: "Sélectionner une entité",
    crm_contact_new: "Nouveau contact",
    crm_contact_edit: "Modifier le contact",
    crm_name: "Nom",
    crm_job_title: "Fonction",
    crm_company: "Société",
    crm_email: "Email",
    crm_phone: "Téléphone",
    crm_notes: "Notes",
    crm_no_people: "Aucun contact.",
    crm_col_entities: "Entités",
    crm_log: "Journaliser",
    crm_settings: "Réglages CRM",
    crm_threshold_label: "Seuil de relance (jours sans contact)",
    crm_threshold_hint: "Les contacts non touchés depuis ce nombre de jours apparaissent dans « Mises à jour requises ».",
    deals_kr: "Key Result lié",
    deals_search_kr: "Rechercher un Key Result…",

    // settings
    settings_title: "Réglages",
    theme: "Thème",
    language: "Langue",
    dark: "Sombre",
    light: "Clair",
    account: "Compte",

    // resources
    res_holdings: "Portefeuille",
    res_invoices: "Factures",
    res_projects: "Projets",
    res_products: "Produits",
    res_orders: "Commandes",
    res_suppliers: "Fournisseurs",
    res_campaigns: "Campagnes",
    res_properties: "Biens",
    res_tenants: "Locataires",
    res_rents: "Loyers",
    res_loans: "Prêts",
    res_maintenance: "Maintenance",
    res_tasks: "Tâches",
    res_documents: "Documents",
    overview: "Aperçu",
    new_entity: "Nouvelle entité",
    onb_title: "Bienvenue sur Cockpit OS",
    onb_subtitle: "Comment souhaitez-vous démarrer ? Vous pourrez tout modifier plus tard.",
    onb_demo_title: "Données de démonstration",
    onb_demo_desc: "Explorez l'application avec 4 entités d'exemple, des factures, des projets, un portefeuille et un CRM déjà remplis.",
    onb_fresh_title: "Partir de zéro",
    onb_fresh_desc: "Démarrez avec un espace de travail entièrement vide et créez vos propres entités.",
    onb_footnote: "Ce choix ne s'affiche qu'une seule fois.",
    onb_start_here: "Commencez ici : créez votre première entité",
    onb_error: "Une erreur s'est produite. Veuillez réessayer.",
    create_entity: "Créer une entité",
    edit_entity: "Modifier l'entité",
    delete_entity: "Supprimer l'entité",
    entity_name: "Nom de l'entité",
    business_type: "Type d'activité",
    country: "Pays",
    legal_form: "Forme juridique",
    tax_regime: "Régime fiscal",
    color: "Couleur",
    description: "Description",
    included_tools: "Outils inclus",
    create: "Créer",
    optional: "(optionnel)",
    confirm_delete_entity: "Supprimer cette entité et toutes ses données ? Action irréversible.",
    sections_label: "Sections / outils",
    sections_hint: "Activez les outils dont cette entité a besoin (mixez et associez librement).",
    add_section: "Ajouter une section",
    starter_checklist: "Générer une check-list de démarrage",
    starter_checklist_hint: "Crée automatiquement les tâches et échéances clés (fiscal, juridique, mise en place) selon le pays, la forme juridique et l'activité.",
    starter_checklist_created: "Entité créée — votre check-list de démarrage est dans l'onglet Tâches.",
    health_healthy: "En bonne santé",
    health_needs_attention: "À surveiller",
    health_at_risk: "À risque",
    health_sig_overdue_invoices: "Factures en retard",
    health_sig_unpaid_rent: "Loyers impayés",
    health_sig_expiring_docs: "Documents expirant",
    health_sig_overdue_tasks: "Tâches en retard",
    health_sig_upcoming_obligations: "Échéances à venir",
    health_sig_low_cashflow: "Cashflow négatif",
    health_sig_stalled_goals: "Objectifs sans progrès",
    health_sig_open_major_bets: "Paris majeurs en cours",
    entity_health: "Santé des entités",
    entity_health_subtitle: "Le pouls de chaque entreprise, des plus à risque aux plus saines.",
    health_all_clear: "Aucun signal — tout va bien.",
    attention_today: "À traiter aujourd'hui",
    attention_is_at_risk: "est à risque",
    attention_is_needs_attention: "demande votre attention",
    attention_view: "Voir l'entité",
    dismiss: "Fermer",
    digest_title: "Digest e-mail",
    digest_subtitle: "Recevez les entités à risque et le briefing IA directement par e-mail.",
    digest_off: "Désactivé",
    digest_daily: "Quotidien",
    digest_weekly: "Hebdomadaire",
    digest_include_ai: "Inclure le briefing IA",
    digest_send_now: "Envoyer maintenant",
    digest_test_label: "Envoyer le digest à cette adresse",
    digest_send_time: "Heure d'envoi (locale)",
    digest_error: "Une erreur s'est produite. Réessayez.",
    role_owner: "Propriétaire",
    role_admin: "Admin",
    role_member: "Membre",
    role_viewer: "Lecteur",
    team_title: "Équipe",
    team_subtitle: "Invitez des collaborateurs sur des entités précises, ou sur tout le groupe.",
    team_invite: "Inviter",
    team_pending: "Invitations en attente",
    team_email_note: "L'envoi d'e-mails n'est pas configuré — vous obtiendrez un lien d'invitation à copier.",
    team_member_removed: "Membre retiré",
    team_purged_count: "{n} éléments résiduels nettoyés",
    select_all: "Tout sélectionner",
    clear_all: "Tout effacer",
    team_role_updated: "Rôle mis à jour",
    team_access_updated: "Accès mis à jour",
    team_manage_access: "Gérer l'accès",
    team_invite_revoked: "Invitation annulée",
    portfolio_investments: "Investissements",
    portfolio_net_worth: "Patrimoine net",
    portfolio_accounts: "Comptes",
    portfolio_holdings: "Lignes",
    portfolio_add_account: "Ajouter un compte",
    portfolio_add_holding: "Ajouter une ligne",
    portfolio_edit_account: "Modifier le compte",
    portfolio_edit_holding: "Modifier la ligne",
    portfolio_cash: "Liquidités",
    portfolio_securities: "Titres",
    portfolio_total: "Total",
    portfolio_shares: "parts",
    portfolio_symbol: "Symbole",
    portfolio_symbol_hint: "Ex. AAPL, AIR.PA (Euronext Paris)",
    portfolio_symbol_search_hint: "Rechercher un nom, un symbole ou un code ISIN…",
    portfolio_quantity: "Quantité",
    portfolio_avg_cost: "Prix de revient moyen",
    portfolio_manual_value: "Valeur (saisie manuelle)",
    portfolio_manual_hint: "Pour les supports sans cotation (fonds euro, etc.)",
    portfolio_account: "Compte",
    portfolio_no_account: "Sans compte",
    portfolio_no_holdings: "Aucune ligne pour le moment.",
    portfolio_no_accounts: "Aucun compte pour le moment.",
    portfolio_type: "Type",
    portfolio_name: "Nom",
    portfolio_currency: "Devise",
    portfolio_lookup: "Vérifier",
    portfolio_price: "Cours",
    portfolio_gain: "Plus-value",
    portfolio_day: "Jour",
    portfolio_custom_label: "Nom du produit",
    portfolio_past: "sur",
    portfolio_holdings_count: "lignes",
    portfolio_total_gain: "Plus-value totale",
    portfolio_symbol_not_found: "Symbole introuvable",
    portfolio_price_verified: "Cours trouvé",
    portfolio_delete_account_confirm: "Supprimer ce compte ? Les lignes seront conservées mais détachées.",
    portfolio_delete_holding_confirm: "Supprimer cette ligne ?",
    portfolio_data_note: "Cours différés via Yahoo Finance, convertis en devise du compte.",
    portfolio_net_contribution: "Apport net",
    portfolio_cost_basis: "Prix de revient",
    portfolio_today_price: "Cours du jour",
    portfolio_unrealized_gain: "Plus-value latente",
    portfolio_position: "Position",
    portfolio_back: "Retour",
    portfolio_cash_adjustment: "Ajustement de liquidités (ajouté au solde du registre)",
    portfolio_edit_cash: "Modifier les liquidités",
    settings_pf_currency: "Devise du portefeuille",
    settings_pf_currency_desc: "Devise principale par défaut pour l'affichage de tous vos portefeuilles.",
    portfolio_currency_inherit: "Global",
    portfolio_currency_saved: "Devise mise à jour",
    activity_title: "Opérations",
    activity_add: "Ajouter une opération",
    activity_edit: "Modifier l'opération",
    activity_none: "Aucune opération enregistrée.",
    activity_your_holdings: "Vos positions",
    import_csv: "Importer",
    import_title: "Importer des opérations (CSV)",
    import_intro: "Importez l'historique d'opérations de votre courtier au format CSV. Les colonnes sont détectées automatiquement ; vous pourrez les ajuster.",
    import_choose_file: "Choisir un fichier CSV",
    import_template: "Télécharger un modèle CSV",
    import_rows: "lignes",
    import_mapping: "Correspondance des colonnes",
    import_valid: "valides",
    import_skipped: "ignorées",
    import_confirm: "Importer",
    import_done: "{n} opérations importées ({s} ignorées)",
    import_error: "Échec de l'import",
    import_field_date: "Date",
    import_field_type: "Type",
    import_field_symbol: "Symbole",
    import_field_name: "Nom",
    import_field_quantity: "Quantité",
    import_field_price: "Cours",
    import_field_fee: "Frais",
    import_field_amount: "Montant",
    import_field_currency: "Devise",
    import_preset: "Format du courtier",
    import_preset_auto: "Détection automatique",
    import_advanced: "Avancé (options / obligations)",
    import_type_from_sign: "Type déduit du signe de la quantité (achat = +, vente = −).",
    import_type_from_desc: "Type déduit du libellé de l'opération (cash book : dividendes, versements, frais…).",
    import_field_asset_type: "Classe d'actif",
    import_field_option_side: "Call / Put",
    import_field_strike: "Strike",
    import_field_expiration: "Échéance",
    import_field_description: "Libellé / description",
    import_field_coupon: "Coupon (%)",
    activity_type: "Type",
    activity_date: "Date",
    activity_amount: "Montant",
    activity_fee: "Frais",
    activity_notes: "Notes",
    activity_realized: "Plus-value réalisée",
    activity_delete_confirm: "Supprimer cette opération ?",
    activity_deleted: "Opération supprimée",
    activity_delete_error: "Échec de la suppression. Veuillez réessayer.",
    activity_details: "Détails",
    entity_base_currency: "Devise principale",
    portfolio_reset: "Réinitialiser le portefeuille",
    portfolio_reset_confirm: "Cela supprimera DÉFINITIVEMENT tous les comptes et opérations de cette entité. Action irréversible.",
    portfolio_reset_confirm_btn: "Tout supprimer",
    portfolio_reset_done: "Portefeuille réinitialisé",
    activity_external_transfer: "Transfert externe",
    activity_from_account: "Compte source",
    activity_to_account: "Compte destination",
    activity_select_source: "Choisir le compte source…",
    activity_select_dest: "Choisir le compte destination…",
    activity_option_contract: "Contrat d'option",
    activity_option_search_hint: "Rechercher un ticker ou contrat…",
    activity_strike: "Prix d'exercice",
    activity_expiration: "Échéance",
    activity_coupon: "Coupon (%)",
    activity_maturity: "Maturité",
    portfolio_expiry: "Exp.",
    portfolio_coupon: "Coupon",
    portfolio_maturity: "Maturité",
    portfolio_holdings_title: "Lignes du portefeuille",
    portfolio_all_classes: "Toutes les classes",
    portfolio_filtered_by: "Filtré par",
    portfolio_expiring_soon: "Expire bientôt",
    portfolio_expired: "Expiré",
    portfolio_days_short: "j",
    portfolio_expiring_header: "à surveiller",
    activity_contracts: "Contrats",
    activity_premium: "Prime / part",
    activity_dividend_type: "Type de dividende",
    activity_asset: "Actif",
    activity_shares_received: "Parts reçues",
    activity_interest_type: "Type d'intérêt",
    activity_currency: "Devise",
    loading: "Chargement…",
    continue: "Continuer",
    assets_title: "Actifs & passifs",
    assets_net: "Net",
    assets_add: "Ajouter",
    assets_add_title: "Ajouter un actif",
    assets_pick_type: "Sélectionnez le type d'actif à ajouter",
    assets_none: "Aucun actif ou passif. Ajoutez vos biens, véhicules, métaux précieux et dettes.",
    assets_none_assets: "Aucun actif",
    assets_none_liabilities: "Aucun passif",
    assets_assets: "Actifs",
    assets_liabilities: "Passifs",
    assets_asset: "Actif",
    assets_liability: "Passif",
    assets_live: "En direct",
    assets_details_sub: "Renseignez les détails de votre actif",
    assets_liability_sub: "Ajoutez un passif à suivre dans votre patrimoine net",
    assets_liability_type: "Type de passif",
    assets_name: "Nom",
    assets_name_ph_asset: "Maison de plage, Appartement…",
    assets_name_ph_liability: "Prêt immobilier, Prêt auto…",
    assets_currency: "Devise",
    assets_metal: "Métal",
    assets_quantity_oz: "Quantité (oz troy)",
    assets_metal_cost_oz: "Prix d'achat / oz",
    assets_sell_quantity: "Quantité à vendre",
    assets_held: "détenu :",
    assets_all: "Tout",
    assets_price_per_oz: "Prix de vente / oz",
    assets_partial_note: "Vente partielle — il restera {n} oz dans cette position.",
    assets_spot: "Cours spot",
    assets_current_value: "Valeur actuelle",
    assets_current_balance: "Solde actuel",
    assets_value_date: "Date de valeur",
    assets_balance_date: "Date du solde",
    assets_purchase_price: "Prix d'achat",
    assets_original_amount: "Montant initial",
    assets_purchase_date: "Date d'achat",
    assets_origination_date: "Date d'origine",
    assets_track_gain: "Sert à calculer la plus-value latente",
    assets_track_paydown: "Sert à suivre le remboursement de la dette",
    assets_link_mortgage: "Créer et associer un prêt immobilier",
    assets_create_asset: "Créer l'actif",
    assets_add_liability: "Ajouter le passif",
    assets_created: "Actif créé",
    assets_saved: "Actif mis à jour",
    assets_deleted: "Élément supprimé",
    assets_delete_error: "Échec de la suppression. Veuillez réessayer.",
    assets_delete_confirm: "Supprimer définitivement cet élément ? Cette action est irréversible.",
    assets_valuation_history: "Historique de valorisation",
    assets_add_valuation: "Ajouter",
    assets_valuation_hint: "Ajoutez des valeurs datées pour que cet actif évolue dans le temps sur le graphique.",
    assets_sell: "Vendre",
    assets_sold: "Vendu",
    assets_closed: "Soldé",
    assets_sold_toast: "Actif vendu",
    assets_sale_error: "Échec de la vente. Veuillez réessayer.",
    assets_confirm_sale: "Confirmer la vente",
    assets_sale_price: "Prix de vente",
    assets_sale_date: "Date de vente",
    assets_sale_fees: "Frais de vente",
    assets_deposit_proceeds: "Déposer le produit net sur un compte",
    assets_no_deposit: "Ne pas déposer (garder hors comptes)",
    assets_mortgage_payoff: "Remboursement du prêt",
    assets_net_cash: "Produit net (en poche)",
    assets_capital_gain: "Plus-value",
    assets_realized_gain: "Plus-value réalisée",
    assets_realized_total: "Réalisé :",
    assets_mortgage_close_note: "Le prêt associé sera soldé et déduit du produit de la vente.",
    assets_sales_log: "Historique des ventes",
    realized_title: "Plus-values réalisées",
    realized_total: "Total :",
    realized_securities: "Titres",
    realized_assets: "Actifs",
    realized_security: "Titre",
    realized_asset: "Actif",
    realized_sold: "Vendu",
    realized_asset_sale: "Vente d'actif",
    realized_export: "Exporter",
    realized_export_csv: "Exporter en CSV",
    realized_export_pdf: "Exporter en PDF",
    realized_report_title: "Rapport des plus-values réalisées",
    realized_generated_on: "Généré le",
    realized_col_date: "Date",
    realized_col_kind: "Type",
    realized_col_name: "Désignation",
    realized_col_detail: "Détail",
    realized_col_proceeds: "Produit",
    realized_col_gain: "Plus-value",
    realized_col_gain_base: "Plus-value",
    realized_period: "Période",
    realized_all_years: "Toutes années",
    realized_no_events_period: "Aucune plus-value sur cette période.",
    alloc_title: "Répartition",
    alloc_net_worth: "Patrimoine",
    alloc_liabilities: "Passifs",
    alloc_empty: "Aucune donnée à répartir pour le moment.",
    portfolio_open_account_hint: "Ouvrez un compte pour voir ses positions et ajouter des opérations.",
    portfolio_copy_link: "Copier le lien du compte",
    portfolio_link_copied: "Lien copié",
    portfolio_prices_as_of: "Cours à",
    networth_incl: "dont",
    networth_converted: "convertis",
    invite_email: "E-mail",
    invite_role: "Rôle",
    invite_access: "Accès",
    invite_specific_entities: "Entités précises",
    invite_whole_group: "Tout le groupe",
    invite_pick_entity: "Sélectionnez au moins une entité",
    invite_send: "Envoyer l'invitation",
    invite_sent_to: "Invitation envoyée à",
    invite_link_ready: "Lien d'invitation prêt — partagez-le.",
    invite_link_copied: "Lien copié",
    invite_copy: "Copier",
    invite_done: "Terminé",
    invite_you_invited: "Vous êtes invité à rejoindre",
    invite_accept: "Accepter l'invitation",
    invite_login_to_accept: "Se connecter / s'inscrire pour accepter",
    invite_wrong_account: "Cette invitation est destinée à {email}. Connectez-vous avec cette adresse.",
    invite_invalid: "Cette invitation n'est plus valide.",
    invite_go_home: "Aller à l'accueil",    digest_sending: "Envoi…",
    digest_saved: "Préférences enregistrées",
    digest_sent: "Digest envoyé à",
    digest_preview_ready: "E-mail non configuré (SMTP) — aperçu généré côté serveur.",
    digest_send_failed: "Échec de l'envoi. En mode test Resend, l'envoi n'est possible que vers votre adresse vérifiée — vérifiez un domaine pour envoyer partout.",
    digest_not_configured: "Envoi d'e-mails non configuré (SMTP). Les préférences sont enregistrées ; activez SMTP pour l'envoi automatique.",
    delete_entity_warning: "Cette action est irréversible. Toutes les données de cette entité (tâches, factures, loyers, documents, etc.) seront définitivement supprimées.",
    delete_entity_confirm_label: "Pour confirmer, saisissez le nom exact de l'entité :",
    delete_permanently: "Supprimer définitivement",
  },
  en: {
    app_name: "Cockpit OS",
    app_tagline: "Operating System",
    login_title: "Run your whole group from a single screen",
    login_subtitle:
      "All your companies at a glance, and every entity in detail, all in one place.",
    login_google: "Continue with Google",
    login_features_1: "Real-time group dashboard",
    login_features_2: "Automatic alerts & cross-entity OKRs",
    login_features_3: "Shared contacts & documents",
    signing_in: "Signing in…",
    auth_signin_title: "Sign in",
    auth_signup_title: "Create your account",
    auth_name_placeholder: "Name (optional)",
    auth_email_placeholder: "Email address",
    auth_password_placeholder: "Password",
    auth_signin_cta: "Sign in",
    auth_signup_cta: "Create account",
    auth_or: "or",
    auth_no_account: "Don't have an account?",
    auth_have_account: "Already have an account?",
    auth_error_generic: "Something went wrong. Please try again.",
    auth_forgot_link: "Forgot password?",
    auth_forgot_title: "Reset your password",
    auth_forgot_subtitle: "Enter your email and we'll send you a reset link.",
    auth_forgot_cta: "Send reset link",
    auth_forgot_sent: "If an account exists for that email, a reset link has just been sent.",
    auth_back_to_signin: "Back to sign in",
    auth_dev_link_note: "Email not configured — test link:",
    auth_reset_title: "Choose a new password",
    auth_reset_subtitle: "Enter a new password for your account.",
    auth_new_password: "New password",
    auth_confirm_password: "Confirm password",
    auth_reset_cta: "Reset password",
    auth_reset_success: "Password reset. You can now sign in.",
    auth_passwords_no_match: "Passwords do not match.",
    auth_reset_invalid: "Invalid or expired reset link.",
    auth_go_to_signin: "Go to sign in",

    nav_home: "Group home",
    nav_okr: "OKR",
    nav_deals: "Deals",
    deals_new: "New deal",
    deals_edit: "Edit deal",
    deals_kanban: "Pipeline",
    deals_table: "Table",
    deals_stages: "Stages",
    deals_manage_stages: "Manage stages",
    deals_add_stage: "Add a stage",
    deals_empty: "No deals yet. Create your first deal.",
    deals_open_value: "Open pipeline:",
    deals_won_value: "Won:",
    deals_probability: "Probability %",
    deals_source: "Source",
    deals_contacts: "Linked contacts",
    deals_col_title: "Title",
    deals_col_company: "Company",
    deals_col_stage: "Stage",
    deals_col_value: "Value",
    deals_col_close: "Expected close",
    deals_col_owner: "Owner",
    deals_col_project: "Project",
    deals_search_company: "Search a company…",
    deals_search_project: "Search a project…",
    deals_people_filtered: "filtered by company",
    deals_no_company_people: "No contacts linked to this company yet.",
    deals_invoice: "Invoice",
    deal_won_title: "Deal won 🎉",
    deal_won_body: "Create a draft invoice for \"{title}\" ({value})?",
    deal_won_create: "Create invoice",
    deal_won_skip: "Later",
    companies_search: "Search a company…",
    companies_all_entities: "All entities",
    companies_empty: "No companies.",
    company_new: "New company",
    company_edit: "Edit company",
    company_name_required: "Name is required",
    company_website: "Website",
    company_industry: "Industry",
    company_location: "Location",
    company_entities: "Linked entities",
    company_notes: "Notes",
    stage_open: "Open",
    stage_won: "Won",
    stage_lost: "Lost",
    deal_activity: "Activity & notes",
    deal_add_note: "Add a note…",
    deal_no_activity: "No activity yet.",
    deal_act_created: "Deal created",
    deal_act_stage: "Stage changed",
    deal_aging_label: "{days}d in stage",
    deal_aging_stale: "Stale · {days}d",
    deal_aging_days_short: "d",
    deal_aging_tooltip: "No stage change in {days} days",
    sales_title: "Sales pipeline",
    sales_deals: "deals",
    nav_contacts: "Contacts",
    nav_documents: "Documents",
    drive_upload: "Upload",
    drive_new_folder: "New folder",
    drive_folder_name: "Folder name",
    drive_empty: "This folder is empty",
    drive_drop_here: "Drop files to upload",
    drive_col_name: "Name",
    drive_col_size: "Size",
    drive_col_modified: "Modified",
    drive_col_owner: "Uploaded by",
    drive_download: "Download",
    drive_rename: "Rename",
    drive_move: "Move",
    drive_delete: "Delete",
    drive_storage_used: "used",
    drive_storage: "Storage",
    drive_not_configured_title: "Storage not configured",
    drive_not_configured: "File storage isn't set up yet. Ask your admin to configure it in Admin then Storage.",
    drive_uploading: "Uploading…",
    drive_upload_failed: "Upload failed",
    drive_uploaded: "File uploaded",
    drive_deleted: "Deleted",
    drive_folder_created: "Folder created",
    drive_renamed: "Renamed",
    drive_moved: "Moved",
    drive_view_list: "List",
    drive_view_grid: "Grid",
    drive_from_board: "Board",
    drive_selected: "selected",
    drive_move_here: "Move here",
    drive_root: "Documents",
    drive_create: "Create",
    drive_save: "Save",
    drive_cancel: "Cancel",
    drive_too_large: "File too large (max 25 MB)",
    drive_col_expiry: "Expiry",
    drive_set_expiry: "Set expiry",
    drive_expiry: "Expiry / renewal",
    drive_expiry_hint: "Track contracts and documents to renew — powers the dashboard expiry alerts.",
    drive_clear_expiry: "Clear expiry",
    drive_no_expiry: "No expiry",
    nav_entities: "Entities",
    nav_shared: "Shared",
    nav_settings: "Settings",
    nav_logout: "Log out",

    period_month: "This month",
    period_ytd: "YTD",
    period_all: "All time",

    group_hq: "Group HQ",
    hq_expiring_title: "Contracts expiring soon",
    hq_expiring_in: "Expires in",
    entities: "entities",
    kpi_net_cashflow: "Group net cashflow",
    kpi_open_tasks: "Open tasks",
    kpi_portfolio: "Portfolio value",
    kpi_rent: "Rent collected",
    vs_last_month: "vs last month",
    overdue: "overdue",
    pending: "pending",
    mtd: "MTD",
    cashflow_by_entity: "Cashflow by entity",
    alerts: "Alerts",
    items: "items",
    open_tasks: "Open tasks",
    see_all: "See all",
    detail: "Detail",
    portfolio: "Portfolio",
    rents: "Rents",
    invoices: "Invoices",
    ecommerce: "Ecommerce",
    revenue: "Revenue",
    orders: "Orders",
    avg_margin: "Avg margin",
    low_stock: "Low stock alerts",
    active_campaigns: "Active campaigns",
    days_overdue: "days overdue",
    due: "Due",
    done: "Done",
    no_alerts: "No alerts. Everything is under control.",
    ai_briefing: "AI daily briefing",
    ai_generate: "Generate briefing",
    ai_generating: "Generating…",
    ai_regenerate: "Regenerate",

    okr_title: "OKR — Objectives & Key Results",
    okr_subtitle: "Objectives → Key Results → Team goals, across all entities",
    okr_empty: "No OKRs yet. Create an objective and key results below.",
    board: "Board",
    board_none: "No board for this project yet.",
    board_item: "Item",
    board_add_item: "Add item",
    board_add_column: "Add column",
    board_edit_column: "Edit column",
    board_edit_options: "Edit options",
    board_options: "Options",
    board_add_option: "Add option",
    board_color: "Color",
    board_done_state: "Done",
    board_done_hint: "Mark this option as 'done' (counts as completed work)",
    board_open: "Open",
    board_group: "Group",
    board_group_color: "Group color",
    board_delete_group: "Delete group",
    board_updates: "Activity",
    board_updates_soon: "Team messages coming soon.",
    board_subitem: "Subitem",
    board_subitems: "Subitems",
    board_add_subitem: "+ Add subitem",
    board_subitem_hint: "Enter to add",
    board_add_subcolumn: "Add subitem column",
    board_drag_hint: "Drag to move",
    board_nest_here: "Make subitem",
    board_promote: "Promote to item",
    board_search_people: "Search people…",
    board_no_members: "No members found",
    role_owner: "Owner",
    role_admin: "Admin",
    role_member: "Member",
    role_manager: "Manager",
    role_super_admin: "Super admin",
    invite_specific_spaces: "Specific spaces",
    invite_pick_space: "Select at least one space",
    scope_super_admin_note: "Full group access — every entity and every space.",
    scope_no_spaces: "No spaces yet. Create spaces first.",
    board_add_group: "Add group",
    board_column_type: "Column type",
    board_column_label: "Column name",
    board_view_table: "Table",
    board_view_kanban: "Kanban",
    board_view_gantt: "Gantt",
    board_view_dashboard: "Dashboard",
    report_error: "Could not load the report.",
    report_total: "Total",
    report_open: "Open",
    report_done: "Done",
    report_overdue: "Overdue",
    report_completion: "Completion",
    report_by_status: "Status breakdown",
    report_owner_workload: "Owner workload",
    report_no_open: "No open items.",
    report_unassigned: "Unassigned",
    report_unknown_user: "User",
    report_completion_trend: "Completion over time",
    report_created: "Created",
    report_completed: "Completed",
    report_delivery_title: "Project delivery",
    report_delivery_error: "Couldn't load project delivery.",
    report_export: "Export CSV",
    soon: "Soon",
    board_group_by: "Group by",
    board_no_status: "No status",
    board_kanban_no_status: "Add a Status, Priority or Dropdown column to use Kanban.",
    board_gantt_no_dates: "Add a Date or Timeline column, then set some dates to show the Gantt.",
    board_gantt_date_col: "Date column",
    board_today: "Today",
    board_no_date: "No date",
    board_tasks: "Items",
    board_gantt_hint: "Drag a bar to reschedule, drag its edges to resize.",
    gantt_add_item: "Add item",
    expand_all: "Expand all",
    collapse_all: "Collapse all",
    zoom_day: "Day",
    zoom_week: "Week",
    zoom_month: "Month",
    zoom_quarter: "Quarter",
    zoom_year: "Year",
    gantt_link_hint: "Drag the dot on a bar's right edge onto another bar to create a dependency.",
    gantt_remove_dep: "Click to remove dependency",
    gantt_pan_left: "Pan left",
    gantt_pan_right: "Pan right",
    drawer_details: "Details",
    drawer_description_placeholder: "Add a description…",
    mention_everyone: "everyone",
    mention_everyone_hint: "Everyone on this space",
    tab_updates: "Updates",
    tab_files: "Files",
    tab_activity: "Activity Log",
    updates_placeholder: "Write an update…  use @ to mention",
    updates_reply_placeholder: "Reply…",
    updates_mention_hint: "@ to mention · **bold** *italic* `code` · ⌘/Ctrl + Enter to send",
    updates_post: "Post",
    updates_empty: "No updates yet. Start the conversation.",
    updates_deleted: "Update deleted",
    updates_error: "Something went wrong",
    files_add: "Attach a file",
    files_empty: "No files attached",
    files_uploaded: "File added",
    files_deleted: "File deleted",
    files_download: "Download",
    files_error: "File failed",
    act_empty: "No activity yet",
    act_created: "created this item",
    act_commented: "posted an update",
    act_renamed: "renamed to",
    act_moved_group: "moved to",
    act_deps: "updated dependencies",
    act_description: "updated the description",
    mentions_title: "Mentions",
    mentions_on: "mentioned you on",
    mentions_mark_all: "Mark all read",
    mentions_dismiss: "Mark as done",
    nav_inbox: "Inbox",
    nav_advisory: "Advisory",
    adv_title: "Advisory",
    adv_subtitle: "Your AI advisory board reviewing the business from your Cockpit OS data",
    adv_tab_review: "Performance Review",
    adv_tab_board: "Board Meeting",
    adv_tab_history: "History / Log",
    adv_board_soon: "Board Meeting mode is coming soon.",
    adv_board_soon_desc: "An interactive meeting where advisors challenge your decisions. Shipping in a later phase.",
    adv_range: "Range",
    adv_this_week: "This week",
    adv_last_week: "Last week",
    adv_this_month: "This month",
    adv_last_month: "Last month",
    adv_custom: "Custom",
    adv_from: "From",
    adv_to: "To",
    adv_scope: "Scope",
    adv_scope_group: "Whole group",
    adv_scope_entity: "One entity",
    adv_scope_entities: "Selected entities",
    adv_generate: "Generate Review",
    adv_generating: "Advisors are analysing your data…",
    adv_generating_hint: "This usually takes 1–2 minutes.",
    adv_error: "Generation failed. Please try again.",
    adv_summary: "Summary",
    adv_improvements: "Improvements since last review",
    adv_regressions: "Regressions since last review",
    adv_risks: "Risks",
    adv_findings: "Findings",
    adv_recommendations: "Recommendations",
    adv_sources: "Sources",
    adv_actions: "Recommended actions",
    adv_status_healthy: "Healthy",
    adv_status_needs_attention: "Needs Attention",
    adv_status_at_risk: "At Risk",
    adv_create_task: "Create task",
    adv_create_project: "Create project",
    adv_snooze: "Snooze",
    adv_accept: "Accept",
    adv_ignore: "Ignore",
    adv_done: "Done",
    adv_act_open: "Open",
    adv_act_snoozed: "Snoozed",
    adv_act_accepted: "Accepted",
    adv_act_ignored: "Ignored",
    adv_act_done: "Done",
    adv_no_reviews: "No reviews yet. Generate your first performance review.",
    adv_history: "Previous reviews",
    adv_view: "View",
    adv_delete: "Delete",
    adv_select_entity: "Select an entity",
    adv_select_space: "Select a space",
    adv_pick_target: "Where should this be created?",
    adv_created_ok: "Created successfully",
    adv_at_risk_count: "at risk",
    adv_attention_count: "needs attention",
    bm_start: "Start Board Meeting",
    bm_new: "New meeting",
    bm_agenda: "Agenda",
    bm_title: "Meeting title",
    bm_question: "Question / decision / proposal",
    bm_entity: "Linked entity (optional)",
    bm_none: "None",
    bm_outcome: "Desired outcome (optional)",
    bm_constraints: "Constraints (optional)",
    bm_advisors_optional: "Advisors (optional)",
    bm_advisors_hint: "Leave empty to let the Chief of Staff pick the most relevant ones.",
    bm_linked_project: "Linked project (optional)",
    bm_linked_goal: "Linked goal (optional)",
    bm_linked_deal: "Linked deal (optional)",
    bm_create: "Convene the board",
    bm_summary_title: "Chief of Staff summary",
    bm_proposing: "What you're proposing",
    bm_why: "Why",
    bm_upside: "Expected upside",
    bm_downside: "Possible downside",
    bm_known_data: "Known data (Cockpit OS)",
    bm_missing: "Missing assumptions",
    bm_confirm_start: "Confirm & start the meeting",
    bm_questions_title: "Board questions",
    bm_answer_ph: "Your answer…",
    bm_submit_answers: "Submit my answers",
    bm_followups_title: "Follow-up questions",
    bm_skip_followups: "Skip to verdict",
    bm_get_verdict: "Get the verdict",
    bm_verdict_title: "Board verdict",
    bm_recommendation: "Recommendation",
    bm_confidence: "Confidence",
    bm_strong: "Strong assumptions",
    bm_weak: "Weak assumptions",
    bm_contradictions: "Contradictions",
    bm_unanswered: "Unanswered questions",
    bm_risks: "Risks",
    bm_data_for: "Data that supports",
    bm_data_against: "Data that argues against",
    bm_cheapest: "Cheapest validation test",
    bm_objections: "Advisor objections",
    bm_suggested_docs: "Suggested documents",
    bm_followup_date: "Follow-up date",
    bm_decision_log: "Decision log entry",
    bm_save_log: "Save to Decision Log",
    bm_saved: "Saved to Decision Log",
    bm_working: "The board is working…",
    bm_status_summarizing: "Preparing the summary…",
    bm_status_questioning: "The board is preparing its questions…",
    bm_status_reviewing: "Reviewing your answers…",
    bm_status_deliberating: "The board is deliberating…",
    rec_proceed: "Proceed",
    rec_proceed_with_conditions: "Proceed with conditions",
    rec_delay: "Delay",
    rec_reject: "Reject",
    rec_needs_more_data: "Needs more data",
    log_filter_all: "All",
    log_filter_reviews: "Reviews",
    log_filter_decisions: "Decisions",
    log_type_review: "Review",
    log_type_decision: "Decision",
    hq_advisory_followups: "Decision follow-ups",
    hq_followup_due: "Due",
    auto_title: "Auto review",
    auto_subtitle: "Automatically generate a performance review on a schedule.",
    auto_freq: "Frequency",
    auto_off: "Off",
    auto_weekly: "Weekly",
    auto_monthly: "Monthly",
    auto_scope: "Scope",
    auto_in_digest: "Include in digest email",
    auto_save: "Save",
    auto_saved: "Automation saved",
    auto_cost_note: "Each run uses AI credits.",
    inbox_subtitle: "Mentions and activity from projects you watch",
    inbox_mentions: "Mentions",
    inbox_watching: "Watching",
    inbox_no_mentions: "No mentions yet",
    inbox_no_watching: "Nothing new on the projects you watch",
    inbox_posted: "posted on",
    inbox_added: "added",
    inbox_status_changed: "changed the status of",
    board_watch: "Watch",
    board_watching: "Watching",
    autom_button: "Automations",
    autom_title: "Board automations",
    autom_empty: "No automations yet. Create a \"when… then…\" rule.",
    autom_new_rule: "New rule",
    autom_when: "When",
    autom_then: "Then",
    autom_add_action: "Add action",
    autom_name_optional: "Name (optional)",
    autom_name_placeholder: "e.g. Notify owner on completion",
    autom_saved: "Automation saved",
    autom_save_failed: "Could not save",
    autom_deleted: "Automation deleted",
    autom_enabled: "Enabled",
    autom_disabled: "Disabled",
    autom_trig_status_change: "Status changes to…",
    autom_trig_item_created: "An item is created",
    autom_trig_due_overdue: "A due date passes",
    autom_trig_overdue_short: "is overdue",
    autom_act_notify_owner: "Notify owner",
    autom_act_move_group: "Move to a group",
    autom_act_set_value: "Set a value",
    autom_act_complete_subitems: "Complete subitems",
    autom_act_move_to: "Move to",
    autom_act_set: "Set",
    autom_quick_add: "Quick add",
    autom_tpl_notify_done: "Notify owner on completion",
    autom_tpl_move_done: "Move to \"Done\" on completion",
    autom_tpl_complete_subs: "Complete subitems on completion",
    autom_tpl_overdue: "Alert when overdue",
    recur_button: "Recurring",
    recur_title: "Recurring items",
    recur_empty: "No recurring templates yet. Create one (e.g. \"VAT — monthly\").",
    recur_new: "New template",
    recur_name: "Name",
    recur_name_placeholder: "e.g. File VAT return",
    recur_name_required: "Name is required",
    recur_frequency: "Frequency",
    recur_next_run: "Next run",
    recur_into_group: "Create in group",
    recur_saved: "Template saved",
    recur_save_failed: "Could not save",
    recur_deleted: "Template deleted",
    recur_ran: "Item created",
    recur_run_now: "Run now",
    recur_none: "Don't repeat",
    recur_daily: "Daily",
    recur_weekly: "Weekly",
    recur_monthly: "Monthly",
    recur_quarterly: "Quarterly",
    recur_annually: "Annually",
    recur_item_label: "Recurrence",
    recur_item_hint: "On completion, a fresh occurrence is created automatically.",
    invite_projects_hint: "Leave empty to grant access to all projects in the chosen spaces.",
    invite_no_projects: "No projects in the selected spaces",
    invite_operational: "Operational access",
    invite_operational_hint: "Also see operational tabs (invoices, portfolio…) of the relevant entities.",
    notif_title: "Notifications",
    notif_subtitle: "Get notified when someone @-mentions you in an update.",
    notif_inapp: "In-app notifications",
    notif_email: "Email notifications",
    notif_saved: "Preferences saved",
    board_subitems_count: "subitems",
    board_back_to_parent: "Back to parent item",
    tab_spaces: "Spaces",
    spaces_intro: "Organize this entity's work into functional spaces.",
    add_space: "Add space",
    no_spaces: "No spaces yet. Add one to get started.",
    choose_space: "Choose a space",
    custom_space: "Custom space",
    space_name: "Space name",
    spaces_label: "Spaces",
    spaces_form_hint: "Functional areas pre-filled from the business type. Editable later.",
    goals: "Goals",
    projects: "Projects",
    add_goal: "Add goal",
    add_project: "Add project",
    no_goals: "No goals yet.",
    no_projects: "No projects yet.",
    new_goal: "New goal",
    edit_goal: "Edit goal",
    add_subgoal: "Add subgoal",
    new_project: "New project",
    edit_project: "Edit project",
    goal_name: "Goal name",
    project_name: "Project name",
    parent_group_okr: "Linked group OKR",
    parent_goal: "Parent goal",
    champion: "Champion",
    start_date: "Start date",
    due_date: "Due date",
    status: "Status",
    priority: "Priority",
    prio_low: "Low",
    prio_medium: "Medium",
    prio_high: "High",
    targets: "Targets",
    add_target: "Add target",
    no_targets: "No quantitative targets.",
    target_name: "Target name",
    target_value: "Target",
    start: "Start",
    current: "Current",
    unit: "Unit",
    checklist: "Checklist",
    add_check_placeholder: "Add an item…",
    subgoals_projects: "Subgoals & projects",
    goal: "Goal",
    project: "Project",
    no_subitems: "No subgoals or projects yet.",
    back: "Back",
    milestones: "Milestones",
    milestone_name: "Milestone name",
    no_milestones: "No milestones yet.",
    task: "Task",
    task_name: "Task name",
    other_tasks: "Other tasks",
    resources: "Resources",
    add_resource: "Add resource",
    resource_label: "Label",
    no_resources: "No resources. Add links to your docs or tools.",
    add_task: "Add task",
    new_task: "New task",
    edit_task: "Edit task",
    no_tasks: "No tasks yet.",
    milestone: "Milestone",
    impact_short: "I",
    effort_short: "E",
    priorities_title: "What to work on next",
    priorities_subtitle: "Your most important open items, by priority quadrant and due date.",
    focus_quick_wins_label: "quick wins",
    focus_quick_win_label: "quick win",
    focus_overdue_label: "overdue",
    priorities_empty: "Nothing prioritized yet. Add impact & effort to goals, projects or tasks.",
    alignment_title: "Alignment",
    alignment_subtitle: "How key results roll up from the space goals that drive them.",
    objective: "Objective",
    goals_short: "goals",
    manual: "manual",
    linked_goals: "Linked goals",
    kr_title: "Key result",
    kr_progress: "Progress",
    auto_from_goals: "auto from goals",
    linked_key_result: "Linked key result",
    edit_key_result: "Edit key result",
    kr_link_hint: "Link space goals to this key result to roll its progress up automatically.",
    objectives: "Objectives",
    key_results: "Key Results",
    impact_effort: "Impact / Effort matrix",
    impact: "Impact",
    effort: "Effort",
    quick_win: "Quick win",
    major_bet: "Major bet",
    fill_in: "Fill-in",
    thankless: "Thankless task",
    high: "High",
    low: "Low",
    progress: "Progress",
    target: "Target",

    add: "Add",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    confirm_delete: "Delete this item?",
    no_data: "No data yet. Click \u201cAdd\u201d to get started.",
    search: "Search…",
    none: "—",
    all_entities: "All entities",
    crm_title: "CRM",
    crm_subtitle: "Your shared address book — people and companies, available across every entity.",
    crm_people: "People",
    crm_companies: "Companies",
    crm_filter_entity: "Show",
    crm_all_entities: "All entities",
    crm_tab_all: "All contacts",
    crm_tab_needs: "Needs update",
    crm_needs_none: "All your contacts are up to date.",
    crm_last_contact: "Last contact",
    crm_never_contacted: "Never",
    crm_days_short: "d",
    crm_mark_followed: "Mark as followed up",
    crm_log_title: "Log an interaction",
    crm_interaction_type: "Interaction type",
    crm_interaction_summary: "Summary",
    crm_int_call: "Call",
    crm_int_email: "Email",
    crm_int_meeting: "Meeting",
    crm_int_note: "Note",
    crm_int_other: "Other",
    crm_timeline: "Interaction history",
    crm_no_timeline: "No interactions logged yet.",
    crm_contact_entities: "Entities & roles",
    crm_add_entity_link: "Add an entity",
    crm_select_entity: "Select an entity",
    crm_contact_new: "New contact",
    crm_contact_edit: "Edit contact",
    crm_name: "Name",
    crm_job_title: "Job title",
    crm_company: "Company",
    crm_email: "Email",
    crm_phone: "Phone",
    crm_notes: "Notes",
    crm_no_people: "No contacts.",
    crm_col_entities: "Entities",
    crm_log: "Log",
    crm_settings: "CRM settings",
    crm_threshold_label: "Follow-up threshold (days without contact)",
    crm_threshold_hint: "Contacts untouched for this many days appear under \u201cNeeds update\u201d.",
    deals_kr: "Linked Key Result",
    deals_search_kr: "Search a Key Result\u2026",

    settings_title: "Settings",
    theme: "Theme",
    language: "Language",
    dark: "Dark",
    light: "Light",
    account: "Account",

    res_holdings: "Portfolio",
    res_invoices: "Invoices",
    res_projects: "Projects",
    res_products: "Products",
    res_orders: "Orders",
    res_suppliers: "Suppliers",
    res_campaigns: "Campaigns",
    res_properties: "Properties",
    res_tenants: "Tenants",
    res_rents: "Rents",
    res_loans: "Loans",
    res_maintenance: "Maintenance",
    res_tasks: "Tasks",
    res_documents: "Documents",
    overview: "Overview",
    new_entity: "New entity",
    onb_title: "Welcome to Cockpit OS",
    onb_subtitle: "How would you like to start? You can change everything later.",
    onb_demo_title: "Add demo data",
    onb_demo_desc: "Explore the app with 4 sample entities pre-filled with invoices, projects, a portfolio and a CRM.",
    onb_fresh_title: "Start fresh",
    onb_fresh_desc: "Begin with a completely empty workspace and create your own entities.",
    onb_footnote: "You'll only see this choice once.",
    onb_start_here: "Start here: create your first entity",
    onb_error: "Something went wrong. Please try again.",
    create_entity: "Create entity",
    edit_entity: "Edit entity",
    delete_entity: "Delete entity",
    entity_name: "Entity name",
    business_type: "Business type",
    country: "Country",
    legal_form: "Legal form",
    tax_regime: "Tax regime",
    color: "Color",
    description: "Description",
    included_tools: "Included tools",
    create: "Create",
    optional: "(optional)",
    confirm_delete_entity: "Delete this entity and all its data? This cannot be undone.",
    sections_label: "Sections / tools",
    sections_hint: "Enable the tools this entity needs — mix and match freely.",
    add_section: "Add section",
    starter_checklist: "Generate a starter checklist",
    starter_checklist_hint: "Auto-creates the key tasks and deadlines (tax, legal, set-up) based on country, legal form and activity.",
    starter_checklist_created: "Entity created — your starter checklist is in the Tasks tab.",
    health_healthy: "Healthy",
    health_needs_attention: "Needs attention",
    health_at_risk: "At risk",
    health_sig_overdue_invoices: "Overdue invoices",
    health_sig_unpaid_rent: "Unpaid rent",
    health_sig_expiring_docs: "Documents expiring",
    health_sig_overdue_tasks: "Overdue tasks",
    health_sig_upcoming_obligations: "Upcoming obligations",
    health_sig_low_cashflow: "Negative cashflow",
    health_sig_stalled_goals: "Stalled goals",
    health_sig_open_major_bets: "Open major bets",
    entity_health: "Entity health",
    entity_health_subtitle: "The pulse of every business, riskiest first.",
    health_all_clear: "No signals — all clear.",
    attention_today: "Needs your attention today",
    attention_is_at_risk: "is at risk",
    attention_is_needs_attention: "needs attention",
    attention_view: "View entity",
    dismiss: "Dismiss",
    digest_title: "Email digest",
    digest_subtitle: "Get your at-risk entities and AI briefing delivered straight to your inbox.",
    digest_off: "Off",
    digest_daily: "Daily",
    digest_weekly: "Weekly",
    digest_include_ai: "Include AI briefing",
    digest_send_now: "Send now",
    digest_test_label: "Send the digest to this address",
    digest_send_time: "Send time (local)",
    digest_error: "Something went wrong. Please try again.",
    role_owner: "Owner",
    role_admin: "Admin",
    role_member: "Member",
    role_viewer: "Viewer",
    team_title: "Team",
    team_subtitle: "Invite collaborators to specific entities, or to the whole group.",
    team_invite: "Invite",
    team_pending: "Pending invitations",
    team_email_note: "Email sending isn't configured — you'll get a copy-able invite link instead.",
    team_member_removed: "Member removed",
    team_purged_count: "{n} stray items cleaned up",
    select_all: "Select all",
    clear_all: "Clear all",
    team_role_updated: "Role updated",
    team_access_updated: "Access updated",
    team_manage_access: "Manage access",
    team_invite_revoked: "Invitation revoked",
    portfolio_investments: "Investments",
    portfolio_net_worth: "Net Worth",
    portfolio_accounts: "Accounts",
    portfolio_holdings: "Holdings",
    portfolio_add_account: "Add account",
    portfolio_add_holding: "Add holding",
    portfolio_edit_account: "Edit account",
    portfolio_edit_holding: "Edit holding",
    portfolio_cash: "Cash",
    portfolio_securities: "Securities",
    portfolio_total: "Total",
    portfolio_shares: "shares",
    portfolio_symbol: "Symbol",
    portfolio_symbol_hint: "e.g. AAPL, AIR.PA (Euronext Paris)",
    portfolio_symbol_search_hint: "Search a name, symbol or ISIN…",
    portfolio_quantity: "Quantity",
    portfolio_avg_cost: "Average cost",
    portfolio_manual_value: "Value (manual)",
    portfolio_manual_hint: "For instruments with no quote (euro funds, etc.)",
    portfolio_account: "Account",
    portfolio_no_account: "No account",
    portfolio_no_holdings: "No holdings yet.",
    portfolio_no_accounts: "No accounts yet.",
    portfolio_type: "Type",
    portfolio_name: "Name",
    portfolio_currency: "Currency",
    portfolio_lookup: "Check",
    portfolio_price: "Price",
    portfolio_gain: "Gain",
    portfolio_day: "Day",
    portfolio_custom_label: "Product name",
    portfolio_past: "past",
    portfolio_holdings_count: "holdings",
    portfolio_total_gain: "Total gain",
    portfolio_symbol_not_found: "Symbol not found",
    portfolio_price_verified: "Price found",
    portfolio_delete_account_confirm: "Delete this account? Holdings are kept but detached.",
    portfolio_delete_holding_confirm: "Delete this holding?",
    portfolio_data_note: "Delayed quotes via Yahoo Finance, converted to the account currency.",
    portfolio_net_contribution: "Net Contribution",
    portfolio_cost_basis: "Cost Basis",
    portfolio_today_price: "Today's Price",
    portfolio_unrealized_gain: "Unrealized Gain",
    portfolio_position: "Position",
    portfolio_back: "Back",
    portfolio_cash_adjustment: "Cash adjustment (added to the ledger balance)",
    portfolio_edit_cash: "Edit cash",
    settings_pf_currency: "Portfolio currency",
    settings_pf_currency_desc: "Default main display currency for all your portfolios.",
    portfolio_currency_inherit: "Global",
    portfolio_currency_saved: "Currency updated",
    activity_title: "Activity",
    activity_add: "Add activity",
    activity_edit: "Edit activity",
    activity_none: "No activity recorded yet.",
    activity_your_holdings: "Your holdings",
    import_csv: "Import",
    import_title: "Import activities (CSV)",
    import_intro: "Import your broker's transaction history as a CSV. Columns are auto-detected; you can adjust the mapping.",
    import_choose_file: "Choose a CSV file",
    import_template: "Download a CSV template",
    import_rows: "rows",
    import_mapping: "Column mapping",
    import_valid: "valid",
    import_skipped: "skipped",
    import_confirm: "Import",
    import_done: "{n} activities imported ({s} skipped)",
    import_error: "Import failed",
    import_field_date: "Date",
    import_field_type: "Type",
    import_field_symbol: "Symbol",
    import_field_name: "Name",
    import_field_quantity: "Quantity",
    import_field_price: "Price",
    import_field_fee: "Fee",
    import_field_amount: "Amount",
    import_field_currency: "Currency",
    import_preset: "Broker format",
    import_preset_auto: "Auto-detect",
    import_advanced: "Advanced (options / bonds)",
    import_type_from_sign: "Type derived from the quantity sign (buy = +, sell = −).",
    import_type_from_desc: "Type derived from the operation description (cash book: dividends, deposits, fees…).",
    import_field_asset_type: "Asset class",
    import_field_option_side: "Call / Put",
    import_field_strike: "Strike",
    import_field_expiration: "Expiration",
    import_field_description: "Label / description",
    import_field_coupon: "Coupon (%)",
    activity_type: "Type",
    activity_date: "Date",
    activity_amount: "Amount",
    activity_fee: "Fee",
    activity_notes: "Notes",
    activity_realized: "Realized gain",
    activity_delete_confirm: "Delete this activity?",
    activity_deleted: "Activity deleted",
    activity_delete_error: "Could not delete. Please try again.",
    activity_details: "Details",
    entity_base_currency: "Main currency",
    portfolio_reset: "Reset portfolio",
    portfolio_reset_confirm: "This will PERMANENTLY delete all accounts and activities for this entity. This cannot be undone.",
    portfolio_reset_confirm_btn: "Delete everything",
    portfolio_reset_done: "Portfolio reset",
    activity_external_transfer: "External transfer",
    activity_from_account: "From account",
    activity_to_account: "To account",
    activity_select_source: "Select source account…",
    activity_select_dest: "Select destination account…",
    activity_option_contract: "Option contract",
    activity_option_search_hint: "Search a ticker or contract…",
    activity_strike: "Strike price",
    activity_expiration: "Expiration",
    activity_coupon: "Coupon (%)",
    activity_maturity: "Maturity",
    portfolio_expiry: "Exp.",
    portfolio_coupon: "Coupon",
    portfolio_maturity: "Maturity",
    portfolio_holdings_title: "Portfolio holdings",
    portfolio_all_classes: "All classes",
    portfolio_filtered_by: "Filtered by",
    portfolio_expiring_soon: "Expiring soon",
    portfolio_expired: "Expired",
    portfolio_days_short: "d",
    portfolio_expiring_header: "to watch",
    activity_contracts: "Contracts",
    activity_premium: "Premium / share",
    activity_dividend_type: "Dividend type",
    activity_asset: "Asset",
    activity_shares_received: "Shares received",
    activity_interest_type: "Interest type",
    activity_currency: "Currency",
    loading: "Loading…",
    continue: "Continue",
    assets_title: "Assets & liabilities",
    assets_net: "Net",
    assets_add: "Add",
    assets_add_title: "Add New Asset",
    assets_pick_type: "Select the type of asset you want to add",
    assets_none: "No assets or liabilities yet. Track your property, vehicles, precious metals and debt.",
    assets_none_assets: "No assets",
    assets_none_liabilities: "No liabilities",
    assets_assets: "Assets",
    assets_liabilities: "Liabilities",
    assets_asset: "Asset",
    assets_liability: "Liability",
    assets_live: "Live",
    assets_details_sub: "Enter the details for your asset",
    assets_liability_sub: "Add a liability to track against your net worth",
    assets_liability_type: "Liability Type",
    assets_name: "Name",
    assets_name_ph_asset: "Beach House, City Apartment…",
    assets_name_ph_liability: "Home Mortgage, Car Loan…",
    assets_currency: "Currency",
    assets_metal: "Metal",
    assets_quantity_oz: "Quantity (troy oz)",
    assets_metal_cost_oz: "Purchase price / oz",
    assets_sell_quantity: "Quantity to sell",
    assets_held: "held:",
    assets_all: "All",
    assets_price_per_oz: "Sale price / oz",
    assets_partial_note: "Partial sell — {n} oz will remain in this position.",
    assets_spot: "Spot price",
    assets_current_value: "Current Value",
    assets_current_balance: "Current Balance",
    assets_value_date: "Value Date",
    assets_balance_date: "Balance Date",
    assets_purchase_price: "Purchase Price",
    assets_original_amount: "Original Amount",
    assets_purchase_date: "Purchase Date",
    assets_origination_date: "Origination Date",
    assets_track_gain: "Used to calculate unrealized gain",
    assets_track_paydown: "Used to track debt paydown",
    assets_link_mortgage: "Create and link a mortgage",
    assets_create_asset: "Create Asset",
    assets_add_liability: "Add Liability",
    assets_created: "Asset created",
    assets_saved: "Asset updated",
    assets_deleted: "Item deleted",
    assets_delete_error: "Could not delete. Please try again.",
    assets_delete_confirm: "Permanently delete this item? This cannot be undone.",
    assets_valuation_history: "Valuation history",
    assets_add_valuation: "Add",
    assets_valuation_hint: "Add dated values so this asset moves over time on the chart.",
    assets_sell: "Sell",
    assets_sold: "Sold",
    assets_closed: "Closed",
    assets_sold_toast: "Asset sold",
    assets_sale_error: "Sale failed. Please try again.",
    assets_confirm_sale: "Confirm sale",
    assets_sale_price: "Sale price",
    assets_sale_date: "Sale date",
    assets_sale_fees: "Selling fees",
    assets_deposit_proceeds: "Deposit net proceeds into an account",
    assets_no_deposit: "Don't deposit (keep outside accounts)",
    assets_mortgage_payoff: "Mortgage payoff",
    assets_net_cash: "Net cash proceeds",
    assets_capital_gain: "Capital gain",
    assets_realized_gain: "Realized gain",
    assets_realized_total: "Realized:",
    assets_mortgage_close_note: "The linked mortgage will be paid off and deducted from your proceeds.",
    assets_sales_log: "Sales history",
    realized_title: "Realized P&L",
    realized_total: "Total:",
    realized_securities: "Securities",
    realized_assets: "Assets",
    realized_security: "Security",
    realized_asset: "Asset",
    realized_sold: "Sold",
    realized_asset_sale: "Asset sale",
    realized_export: "Export",
    realized_export_csv: "Export to CSV",
    realized_export_pdf: "Export to PDF",
    realized_report_title: "Realized gains report",
    realized_generated_on: "Generated on",
    realized_col_date: "Date",
    realized_col_kind: "Type",
    realized_col_name: "Name",
    realized_col_detail: "Detail",
    realized_col_proceeds: "Proceeds",
    realized_col_gain: "Gain",
    realized_col_gain_base: "Gain",
    realized_period: "Period",
    realized_all_years: "All years",
    realized_no_events_period: "No realized gains in this period.",
    alloc_title: "Allocation",
    alloc_net_worth: "Net worth",
    alloc_liabilities: "Liabilities",
    alloc_empty: "Nothing to allocate yet.",
    portfolio_open_account_hint: "Open an account to see its holdings and add activities.",
    portfolio_copy_link: "Copy account link",
    portfolio_link_copied: "Link copied",
    portfolio_prices_as_of: "Prices as of",
    networth_incl: "incl.",
    networth_converted: "converted",
    invite_email: "Email",
    invite_role: "Role",
    invite_access: "Access",
    invite_specific_entities: "Specific entities",
    invite_whole_group: "Whole group",
    invite_pick_entity: "Select at least one entity",
    invite_send: "Send invitation",
    invite_sent_to: "Invitation sent to",
    invite_link_ready: "Invite link ready — share it.",
    invite_link_copied: "Link copied",
    invite_copy: "Copy",
    invite_done: "Done",
    invite_you_invited: "You're invited to join",
    invite_accept: "Accept invitation",
    invite_login_to_accept: "Log in / sign up to accept",
    invite_wrong_account: "This invite is for {email}. Log in with that email.",
    invite_invalid: "This invitation is no longer valid.",
    invite_go_home: "Go home",
    digest_sending: "Sending…",
    digest_saved: "Preferences saved",
    digest_sent: "Digest sent to",
    digest_preview_ready: "Email not configured (SMTP) — preview generated server-side.",
    digest_not_configured: "Email sending isn't configured (SMTP). Preferences are saved; enable SMTP for automatic delivery.",
    delete_entity_warning: "This action is irreversible. All of this entity's data (tasks, invoices, rents, documents, etc.) will be permanently deleted.",
    delete_entity_confirm_label: "To confirm, type the exact entity name:",
    delete_permanently: "Delete permanently",
  },
};
